import React from 'react';

function ProfitSection() {
  return (
    <section className="bg-white dark:bg-[#15261b] py-20 md:py-32" id="profit">
      <div className="px-4 md:px-10 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Left Content */}
          <div className="flex-1 space-y-8">
            <div className="space-y-4">
              <span className="text-primary font-bold tracking-wider text-sm uppercase">Profit Model</span>
              <h2 className="text-3xl md:text-5xl font-black leading-tight">데이터가 증명하는<br/>확실한 수익성</h2>
              <p className="text-gray-500 dark:text-gray-400 text-lg leading-relaxed">
                직관적인 파트너 관리자 페이지를 통해 실시간 매출과 성과를 확인하세요. 투명한 정산 시스템이 귀하의 성공을 지원합니다.
              </p>
            </div>
            <div className="space-y-6">
              <div className="flex gap-4 items-start">
                <div className="mt-1 min-w-6 text-primary">
                  <span className="material-symbols-outlined">monitoring</span>
                </div>
                <div>
                  <h4 className="text-lg font-bold mb-1">실시간 매출 분석</h4>
                  <p className="text-gray-500 dark:text-gray-400 text-sm">일별, 월별 매출 추이와 인기 상품을 한눈에 파악하여 전략적인 운영이 가능합니다.</p>
                </div>
              </div>
              <div className="flex gap-4 items-start">
                <div className="mt-1 min-w-6 text-primary">
                  <span className="material-symbols-outlined">account_balance_wallet</span>
                </div>
                <div>
                  <h4 className="text-lg font-bold mb-1">투명한 정산 시스템</h4>
                  <p className="text-gray-500 dark:text-gray-400 text-sm">복잡한 계산 없이 자동으로 처리되는 투명하고 정확한 정산 리포트를 제공합니다.</p>
                </div>
              </div>
            </div>
            <button className="flex items-center gap-2 text-[#0e1b12] dark:text-white font-bold border-b-2 border-primary pb-1 hover:text-primary transition-colors">
              수익 구조 자세히 보기 <span className="material-symbols-outlined text-sm">arrow_outward</span>
            </button>
          </div>
          {/* Right Image (Dashboard Mockup) */}
          <div className="flex-1 w-full">
            <div className="relative rounded-xl overflow-hidden shadow-2xl bg-surface-light dark:bg-surface-dark border border-gray-200 dark:border-gray-700 aspect-[4/3] group">
              <div
                className="absolute inset-0 bg-cover bg-center"
                style={{
                  backgroundImage: 'url("https://lh3.googleusercontent.com/aida-public/AB6AXuB0vOkVAfU2_Nn_RLcVdwSZ21xrICP25JNvJmvKLRkn8d1_gYCeP_qBjLG9BNU6OtYP741Dda4U71jaesQDhNfj2kxBBk5owlCuCc3mDHKPgK7Nyg9-dx0prXNRbl8_lZF_v4D_jMWquGedgcMEIyg1tUJ0ij2AXiNEWOe3YwKcfHeoRj0rwZkkDCMMDd03x-38vheQTNiWsz_JUV8yJ0UfnJkOf5r3FVaSGAj_PMDZustZ0yEQCCO_QVeYAN7N84uv914K9hS68xln")'
                }}
              >
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-background-light dark:from-background-dark via-transparent to-transparent opacity-20"></div>
              {/* Floating Stat Card */}
              <div className="absolute bottom-8 left-8 right-8 bg-white/90 dark:bg-[#1a2e22]/90 backdrop-blur-md p-6 rounded-lg border border-gray-100 dark:border-gray-600 shadow-lg transform translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                <div className="flex justify-between items-center mb-4">
                  <span className="text-sm font-medium text-gray-500 dark:text-gray-400">이번 달 총 매출</span>
                  <span className="text-xs font-bold text-primary bg-primary/10 px-2 py-1 rounded-full">+24.5% 상승</span>
                </div>
                <div className="text-3xl font-bold font-display">&#8361; 124,500,000</div>
                <div className="mt-4 h-2 w-full bg-gray-100 dark:bg-gray-700 rounded-full overflow-hidden">
                  <div className="h-full bg-primary w-[75%] rounded-full"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ProfitSection;
